import {createApp, PropType, ref} from 'vue';
import {connectVue} from '../modules/configureBugsnag';
import configureGlobalComponents from '../modules/configureGlobalComponents';
import useVuelidate from '@vuelidate/core';
import {email, helpers, required} from '@vuelidate/validators';

const app = createApp({
    props: {
        formData: {type: Object as PropType<any>},
    },
    data() {
        return {
            ratingOptions: [
                {value: '', text: 'Select used service'},
                {value: '1', text: '★'},
                {value: '2', text: '★★'},
                {value: '3', text: '★★★'},
                {value: '4', text: '★★★★'},
                {value: '5', text: '★★★★★'},
            ],
            serviceOptions: [
                {value: '', text: 'Select used service'},
                {value: 'dealer', text: 'Dealership'},
                {value: 'service', text: 'Service'},
                {value: 'mot', text: 'MOT'},
            ],
        };
    },
    setup(props) {
        const state = {
            name: ref(props.formData.name || ''),
            email: ref(props.formData.email || ''),
            service: ref(props.formData.service || ''),
            rating: ref(props.formData.rating || ''),
            comments: ref(props.formData.comments || ''),
        };

        const rules = {
            name: {
                required: helpers.withMessage('Please enter your name', required),
            },
            email: {
                required: helpers.withMessage('Please enter your email', required),
                email,
            },
            service: {
                required: helpers.withMessage('Please choose a service', required),
            },
            rating: {
                required: helpers.withMessage('Please choose a rating', required),
            },
            comments: {
                required: helpers.withMessage('Please enter your review', required),
            },
        };

        const v = useVuelidate(rules, state);
        async function submitForm(e: Event) {
            e.preventDefault();
            e.stopPropagation();

            const validationPassed = await v.value.$validate();
            if (validationPassed) {
                (document.getElementById('add-review__form') as HTMLFormElement).submit();
            }
        }

        return {
            name: state.name,
            email: state.email,
            service: state.service,
            rating: state.rating,
            comments: state.comments,
            v$: v,
            submitForm,
        };
    },
}, window.propsData);

connectVue(app);
configureGlobalComponents(app);
app.mount('#add-review');
